import Vue from "vue";
import Vuesax from "vuesax";
import VeeValidateEs from "./lang/validations/es";
import VeeValidateEn from "./lang/validations/en";
import App from "./App.vue";
import VCalendar from "v-calendar";
import Treeselect from "@riophae/vue-treeselect";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "material-icons/iconfont/material-icons.css";
// Vuex Store
import store from "./store/store";
// Theme Configurations
import "../themeConfig.js";
// Perfectscrollbar
// import PerfectScrollbar from "vue2-perfect-scrollbar";
// import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
// Vue.use(PerfectScrollbar);
import VueTheMask from "vue-the-mask";
import Vuebar from "vuebar";
import TextHighlight from "vue-text-highlight";
// Theme Configurations
import "prismjs";
import "prismjs/themes/prism.css";
import VueLayers from "vuelayers";
import "vuelayers/lib/style.css";
import VsPrism from "./components/prism/VsPrism.vue";
import VueTreeNavigation from "vue-tree-navigation";
import VsSidebarGroup from "./components/vs-sidebar-group/Sidebar-Group.vue";
// i18n
import i18n from "./i18n/i18n.js";
// Vue Router
import router from "./router";
import VeeValidate from "vee-validate";
import Buefy from "buefy";
import VueSwal from "vue-swal";
import "buefy/dist/buefy.css";
import "@/assets/scss/style.scss";
import { ToastProgrammatic as Toast } from 'buefy';
import { TOAST_TYPES } from "@/global/toast";
import axios from "./axiosConfig";
import SessionActivity from "./global/session-activity";

Vue.use(VueTheMask);

Vue.use(Vuebar);

Vue.component("text-highlight", TextHighlight);

Vue.component(VsPrism.name, VsPrism);

Vue.component(VsSidebarGroup.name, VsSidebarGroup);

Vue.config.productionTip = false;

Vue.component("treeselect", Treeselect);
Vue.use(VueTreeNavigation);
Vue.use(VueLayers);
Vue.use(Buefy);
Vue.use(VueSwal);
Vue.use(Vuesax);
Vue.use(VCalendar);
Vue.use(VeeValidate, {
    locale: "es",
    classes: true,
    dictionary: {
        es: VeeValidateEs,
        en: VeeValidateEn,
    },
});


Vue.prototype.$http = axios;
Vue.prototype.$toast = (message, type = TOAST_TYPES.INFO) => {
    Toast.open({ message, type });
};

Vue.prototype.$toastInfo = (message) => {
    Toast.open({ message, type: TOAST_TYPES.INFO });
};

Vue.prototype.$toastOk = (message) => {
    Toast.open({ message, type: TOAST_TYPES.SUCCESS });
};

Vue.prototype.$toastError = (message) => {
    Toast.open({ message, type: TOAST_TYPES.ERROR });
};

Vue.use(SessionActivity, {
    redirectOnAuthError: false, // Desactivar redirección del plugin, usar solo axiosConfig
})

new Vue({
    store,
    router,
    i18n,
    data: { clientHeight: 0, clientWidth: null },
    render: (h) => h(App),
}).$mount("#app");
